import React, { FC, useEffect } from 'react';
import { BrowserRouter, Route, Navigate, Routes } from 'react-router-dom';
import Wrapper from './components/wrapper';

import overall from './store/overall';

const App: FC = () => {
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <BrowserRouter basename={`/${overall.baseUrl}`}>
      <Routes>
        <Route path="/:vType" element={<Wrapper />} />
        <Route path="/part/:partName" element={<Wrapper />} />
        <Route path="/" element={<Navigate to="/pv" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
